'use client';

import Box from '@mui/material/Box';
import { type SxProps, type Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { fontFamilies } from '../../theme/typography';
import { composeSx } from '../../utils/styledUtils';

export interface CodeCellProps {
  /** Code / ID value (e.g. "LOAN-OMX-2026-0142"). */
  value: ReactNode;
  /** Optional muted prefix/suffix or status icon rendered alongside the code. */
  startAdornment?: ReactNode;
  endAdornment?: ReactNode;
  /** Render value uppercase. Default true. */
  uppercase?: boolean;
  /** Sx overrides for the outer Box. */
  sx?: SxProps<Theme>;
}

export function CodeCell({ value, startAdornment, endAdornment, uppercase = true, sx }: CodeCellProps) {
  return (
    <Box sx={composeSx({ display: 'inline-flex', alignItems: 'center', gap: 0.75 }, sx)}>
      {startAdornment}
      <Typography
        component="span"
        sx={{
          fontFamily: fontFamilies.mono,
          fontSize: '0.75rem',
          fontWeight: 500,
          letterSpacing: '0.02em',
          color: 'text.secondary',
          textTransform: uppercase ? 'uppercase' : 'none',
          fontVariantNumeric: 'tabular-nums',
          whiteSpace: 'nowrap',
        }}
      >
        {value}
      </Typography>
      {endAdornment}
    </Box>
  );
}

CodeCell.displayName = 'CodeCell';

export default CodeCell;
